import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import { StoreOverviewStore, AuthStore, StoreStore } from 'stores';
import { StoreOverviewActions } from 'actions';
import PurchaseDialog from 'components/Store/PurchaseDialog';
import RegisterForm from 'components/RegisterForm';
import FullScreenDialog from 'components/FullScreenDialog';
import shallowCompare from 'react-addons-shallow-compare';
import TaC from '../../components/TaC/StoreTaC';

import { getCart, isGift } from 'selectors/store';

class PurchaseDialogContainer extends mixin(RefluxMixin, Component) {
  state = {
    tac: false
  };

  listenToStores() {
    this.listenToStore(AuthStore, 'auth');
    this.listenToStoreWithMapper(StoreOverviewStore, state => {
      const cart = getCart(state);
      return {
        cart,
        isGift: isGift(state),
        activeDiscountCount: state.activeDiscountCount,
        paymentCompleted: state.payment.completed,
        open: cart.length > 0 && !isGift(state),
        method: state.payment.method,
        countryCode: state.countryCode,
        allowedPaymentProviders: state.allowedPaymentProviders
      };
    });
    this.listenToStoreWithMapper(AuthStore, state => ({
      loggedIn: state.loggedIn
    }));
  }

  clearCart = () => {
    StoreOverviewActions.clearCart();
  };

  closeTac = () => {
    this.setState({ tac: false });
  };

  render() {
    const { loggedIn, isGift, cart, tac } = this.state;
    const { userName, userLocale, router } = this.props;
    if (cart.length < 1 || isGift) {
      return null;
    }
    if (tac) {
      return (
        <TaC username={userName} open={tac} onRequestClose={this.closeTac} />
      );
    }
    if (!loggedIn) {
      return (
        <FullScreenDialog
          {...this.props}
          open
          padded
          toolbar={true}
          onRequestClose={this.clearCart}
        >
          <RegisterForm
            userName={userName}
            userLocale={userLocale}
            router={router}
            onTac={() => this.setState({ tac: true })}
          />
        </FullScreenDialog>
      );
    }
    return (
      <PurchaseDialog
        {...this.state}
        {...this.props}
        onRequestClose={this.clearCart}
      />
    );
  }
}

export default PurchaseDialogContainer;



// WEBPACK FOOTER //
// ./src/js/containers/Store/PurchaseDialog.js